import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import {Table} from "react-bootstrap";
import {setTitle} from "../../CustomerPanelPage/components/ExternalPage/External";

const Td = styled.td`
    vertical-align: middle !important;
`;
export const TableBody = styled(Table)`
    width: auto;
    border: none !important;
    padding: 10px;
`;

@connect(({ clientPanel }) => clientPanel.detailsPageReducer)
export default class DetailedPartTable extends React.Component {
    render() {
        let header = "";
        let content = "";
        let summaryHeader = "";
        let summary = "";
        if (this.props.tableData && this.props.tableData.detailedPartReport) {
            let detailedPartReport = this.props.tableData.detailedPartReport;
            header = (
                <tr>{detailedPartReport.header && detailedPartReport.header.map(i => <th key={i.key} style={{width: i.width, border: 0}} title={setTitle(i.val, this.props.tableData.letterColumnsDescription)}>{i.val}</th>)}</tr>
            );
            if (detailedPartReport.rows) {
                content = detailedPartReport.rows.map((r, index) => {
                    let row = (
                        <tr key={r.partNumber.val + index}>
                            {r.partNumber.rowSpan !== 0 && <Td rowSpan={r.partNumber.rowSpan}>{r.partNumber.val}</Td>}
                            {r.ec.map(r => {
                                let res = r.rowSpan !== 0 ? <Td rowSpan={r.rowSpan}>{r.val}</Td> : null;
                                return res;
                            })}
                            <Td>{r.totalChecked}</Td>
                            <Td>{r.fromThisOk}</Td>
                            <Td>{r.reworked}</Td>
                            {r.reworkDetails.map(d => {
                                return <td>{d.val}</td>;
                            })}
                            <Td>{r.nok}</Td>
                            {r.nokDetails.map(d => {
                                return <td>{d.val}</td>;
                            })}
                            <Td>{r.totalOk}</Td>
                        </tr>
                    );
                    return row;
                });
            }
            summaryHeader = (
                <tr>
                    {detailedPartReport.summaryHeader &&
                        detailedPartReport.summaryHeader.map(i => <td key={i.key}>{i.val}</td>)}
                </tr>
            );
            summary = (
                <tr>
                    {detailedPartReport.summary && detailedPartReport.summary.map((i, idx) => <td key={idx}>{i}</td>)}
                </tr>
            );
        }
        return (
        <>
            <TableBody responsive={true}>
                <tbody>
                {header}
                {content}
                {summaryHeader}
                {summary}
                </tbody>
            </TableBody>
            <div style={{fontWeight: 600, paddingTop: 20}}>{this.props.tableData.dailyPartReport &&this.props.tableData.dailyPartReport.message}</div>
        </>
        );
    }
}
